<template>
  <div>
    <div
      v-for="(flight , index) in items"
      :key="index"
    >
     <PdkFlightAvail :availableFlight="flight"  @selected="$emit('selected', $event)"></PdkFlightAvail>
      <!-- <flight-time :flight="flight" buttonTitle="انتخاب پرواز" @selected="$emit('selected', $event)" /> -->
    </div>
  </div>
</template>
<script>
import flightTime from "@/components/shared/FlightTime"; 
import PdkFlightAvail from "@/components/flight/FlightAvail";
export default {
  components: { "flight-time": flightTime,    PdkFlightAvail,
},
 
  props: {
    items: Array,
  },
};
</script>